import React__default from 'react';
import Box from '../../Box/index.esm.js';
import { getMonth, getYear, setYear, setMonth, format } from 'date-fns';
import Grid from '../../Grid/index.esm.js';
import { FROM_YEAR } from '../constants.esm.js';

var ContentButton = function ContentButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      selected = _ref.selected;
  return React__default.createElement(Box, {
    cursor: "cursor-pointer",
    borderRadius: "rounded-full",
    padding: "py-2",
    backgroundColor: selected ? 'bg-blue-500' : undefined,
    textColor: selected ? 'text-white' : undefined,
    borderWidth: "border-2",
    borderColor: ['border-transparent', 'hover:border-blue-500'],
    onClick: onClick
  }, children);
};

var PickerContent = function PickerContent(_ref2) {
  var setCalendarState = _ref2.setCalendarState,
      monthYear = _ref2.monthYear,
      setMonthYear = _ref2.setMonthYear,
      size = _ref2.size,
      page = _ref2.page,
      displayYear = _ref2.displayYear,
      oldState = _ref2.oldState;

  if (oldState === 'MONTH') {
    return React__default.createElement(Grid, {
      gridTemplateColumns: "grid-cols-3",
      gap: size === 'sm' ? 'gap-x-3' : 'gap-x-5',
      fontSize: size === 'sm' ? 'text-sm' : 'text-base',
      padding: size === 'sm' ? 'px-3' : 'px-4',
      width: "w-full",
      height: "h-full",
      textAlign: "text-center",
      alignItems: "items-center",
      transitionProperty: "transition-all",
      transform: "transform"
    }, Array.from(Array(12).keys()).map(function (i) {
      return React__default.createElement(ContentButton, {
        key: i,
        selected: i === getMonth(monthYear) && displayYear === getYear(monthYear),
        onClick: function onClick() {
          setMonthYear(setYear(setMonth(monthYear, i), displayYear));
          setCalendarState('DAY');
        }
      }, format(new Date(2000, i, 1), 'MMMM'));
    }));
  }

  if (oldState === 'YEAR') {
    return React__default.createElement(Grid, {
      gridTemplateColumns: "grid-cols-3",
      gap: size === 'sm' ? 'gap-x-3' : 'gap-x-5',
      fontSize: size === 'sm' ? 'text-sm' : 'text-base',
      padding: size === 'sm' ? 'px-3' : 'px-4',
      width: "w-full",
      height: "h-full",
      textAlign: "text-center",
      alignItems: "items-center",
      transitionProperty: "transition-all",
      transform: "transform"
    }, Array.from(Array(12).keys()).map(function (i) {
      return React__default.createElement(ContentButton, {
        key: i,
        selected: FROM_YEAR + page * 12 + i === getYear(monthYear),
        onClick: function onClick() {
          setMonthYear(setYear(monthYear, FROM_YEAR + page * 12 + i));
          setCalendarState('DAY');
        }
      }, FROM_YEAR + page * 12 + i);
    }));
  }

  return React__default.createElement(React__default.Fragment, null);
};

export default PickerContent;
//# sourceMappingURL=PickerContent.esm.js.map
